import React from 'react';
import SingleSelectWithoutState from './SingleSelectWithoutState';

const SelectField = (props) => {
  const { value, options, setValue, style = {} } = props;
  const border = style.border || '0.5px solid rgba(115, 115, 115, 0.2)';
  const borderRadius = style.borderRadius || 6;
  const height = style.height || 56;
  const fontSize = style.fontSize || 13;
  return (
    <div style={{ marginBottom: 12 }}>
      <SingleSelectWithoutState
        options={options}
        value={props.multi ? options.filter(o => value.includes(o.value)) : value}
        setValue={newValue => {
          if (props.multi && newValue.includes('_all')) {
            setValue([...value, options.map(o => o.value).filter(o => o !== '_all')].flat());
          } else {
            setValue(newValue);
          }
        }}
        multi={props.multi || false}
        customStyles={{
          placeholder: (defaultStyles) => {
            return {
              ...defaultStyles,
              color: 'rgba(0, 0, 0, 0.4)',
              fontSize: (fontSize + 2) + 'px !important'
            };
          },
          multiValue: (defaultStyles) => {
            return {
              ...defaultStyles,
              border: '1px solid rgba(255,218,24,0.8) !important',
              backgroundColor: 'rgba(255,218,24,0.4) !important'
            };
          },
          multiValueRemove: (styles, { data }) => ({
            ...styles,
            color: 'black !important',
            ':hover': {
              backgroundColor: 'rgba(255,218,24,0.8) !important',
              color: 'black !important'
            }
          }),
          multiValueLabel: (styles, { data }) => ({
            color: data.color,
            padding: 0,
            paddingLeft: 6,
            fontSize: fontSize + 'px !important'
          }),
          container: () => ({
            minHeight: height || 56,
            position: 'relative'
          }),
          control: (provided, state) => {
            return {
            // none of react-select's styles are passed to <Control />
              ...provided,
              borderColor: '',
              width: '100%',
              minHeight: (height || 56) + 'px !important',
              border: /* !state.isFocused ? */ border + ' !important' /* : '0 !important' */,
              // boxShadow: !state.isFocused ? '0px 4px 5px 0px rgba(0, 0, 0, 0.05) !important' : '0px 4px 20px 0px rgba(0, 0, 0, 0.2) !important',
              boxShadow: 'none',
              borderRadius: borderRadius + 'px !important',
              fontFamily: '"Open Sans", sans-serif !important',
              lineHeight: ((height || 56) - 16) + 'px !important',
              paddingLeft: 6,
              backgroundColor: state.hasValue ? 'rgba(6, 179, 6, 0.1) !important' : 'transparent',
              '&:hover': {
                border: /* state.isFocused ? '0 !important' : */ border
              },
              fontSize: (fontSize + 2) + 'px !important'
            }
            ;
          },
          menu: (provided, state) => ({
            ...provided,
            fontSize: (fontSize + 2) + 'px !important'
          }),
          singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';
            return {
              ...provided,
              opacity,
              transition,
              paddingLeft: 0,
              lineHeight: '24px !important',
              fontSize: fontSize + 'px !important'
            };
          }
        }}
      />
    </div>
  );
}
;

export default SelectField;
